import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService } from "src/app/shared/services/data.service";
import { ShoppingCartService } from "src/app/shared/services/shopping-cart.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-shopping-cart",
  templateUrl: "./shopping-cart.component.html",
  styleUrls: ["./shopping-cart.component.scss"]
})
export class ShoppingCartComponent implements OnInit, OnDestroy {
  cart: [];
  totalItemsCount: number;
  totalCartPrice: number;

  cartSubscription: Subscription;
  qtySubscription: Subscription;
  priceSubscription: Subscription;
  constructor(
    private dataService: DataService,
    private cartService: ShoppingCartService
  ) {}

  ngOnInit() {
  
    
    this.cart = this.cartService.cartItems;
    this.totalCartPrice = this.cartService.totalPrice;
    this.totalItemsCount = this.cartService.totalItemsCount;

    let _cart: string;
    _cart = JSON.stringify(this.cart);
    this.cart = JSON.parse(_cart);

    this.cartSubscription = this.dataService.cartItemsSubject.subscribe(
      cartitems => {
        this.cart = cartitems;
        console.log("here" + this.cart);
      }
    );

    this.qtySubscription = this.dataService.cartQtySubject.subscribe(
      quantity => {
        this.totalItemsCount = quantity;
      }
    );

    this.priceSubscription = this.dataService.cartPriceSubject.subscribe(totaPrice => {
      this.totalCartPrice = totaPrice;
    });
  }

  removeFromCart(id){
    this.cartService.remove(id);
  }

  clearCart(){
      this.cartService.empty();
  }
  ngOnDestroy() {
    this.cartSubscription.unsubscribe();
    this.qtySubscription.unsubscribe();
    this.priceSubscription.unsubscribe();
  }

  
}
